import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset } from 'redux-form';
import List from './List';
import Filter from './Filter';
import { loadKindergartenMonthlyReport, exportKindergartenPayments } from './actions';
import utils from '../../../common/services/utils';

class KindergartenMonthlyReport extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const { currentYear, currentMonth } = this.props;

		const filter = { year: currentYear, month: currentMonth };
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleFilterSubmit(options) {
		const { isExport, ...filter } = options;
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (isExport)
			this.exportData(filter);
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { loadReport } = this.props;
		loadReport({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}
	exportData(filter) {
		this.props.exportKindergartenPayments(filter);
	}

	render() {
		const { data, months, years, currentMonth, currentYear } = this.props;
		//const years = [{ id: 2016, name: '2016' }, { id: 2017, name: '2017' }, { id: 2018, name: '2018' }];

		return (
			<div>
				<Filter
					onSubmit={this.handleFilterSubmit}
					months={months}
					years={years}
					initialValues={{ month: currentMonth, year: currentYear }}
					loading={this.props.pagination.loading || this.props.export.loading}
				/>
				<List
					data={data}
					onFetchData={this.handleListEvent}
					{...this.props.pagination}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {

	const {
		pagination,
		exports,
		entities: { kindergartenMonthlyReport },
		lookups: { years, months }
	} = state;

	const kindergartenReportPagination = pagination.kindergartenMonthlyReport.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const kindergartenReportExport = exports.kindergartenReport.all || {};

	return {
		data: kindergartenReportPagination.ids.map(id => kindergartenMonthlyReport[id]),
		pagination: kindergartenReportPagination,
		months,
		years,
		currentMonth: utils.getCurrentMonth(),
		currentYear: utils.getCurrentYear(),
		export: kindergartenReportExport
	};
};

const mapDispatchToProps = {
	loadReport: loadKindergartenMonthlyReport,
	exportKindergartenPayments,
	resetFilter: () => reset('kindergartenMonthlyReportFilter')
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(KindergartenMonthlyReport));